var map = {
	"./abyssal_blade.png": "d9b54",
	"./aegis.png": "ba69",
	"./aeon_disk.png": "5d96",
	"./aether_lens.png": "8a34",
	"./ancient_janggo.png": "2a2a",
	"./apex.png": "5536",
	"./arcane_blink.png": "dd64",
	"./arcane_boots.png": "8073",
	"./arcane_boots2.png": "1903",
	"./arcane_ring.png": "12fe",
	"./armlet.png": "7673",
	"./armlet_active.png": "448d",
	"./assault.png": "7044",
	"./ballista.png": "cfc4",
	"./banana.png": "5554",
	"./band_of_elvenskin.png": "2f1b",
	"./basher.png": "2d24",
	"./belt_of_strength.png": "3a03",
	"./bfury.png": "d549",
	"./black_king_bar.png": "ed5c",
	"./blade_mail.png": "692e",
	"./blade_mail_axe_pw.png": "00bc",
	"./blade_of_alacrity.png": "bbc2",
	"./blades_of_attack.png": "1069",
	"./blight_stone.png": "c4a4",
	"./blink.png": "1d10",
	"./blitz_knuckles.png": "cafe",
	"./bloodstone.png": "6aac",
	"./bloodthorn.png": "d37f",
	"./book_of_shadows.png": "caac",
	"./book_of_the_dead.png": "6341",
	"./boots.png": "8830",
	"./boots_of_elves.png": "6272",
	"./bottle.png": "9148",
	"./bottle_arcane.png": "ac98",
	"./bottle_bounty.png": "0b54",
	"./bottle_doubledamage.png": "c6d9",
	"./bottle_empty.png": "d9e5",
	"./bottle_haste.png": "aa46",
	"./bottle_illusion.png": "9a1a",
	"./bottle_invisibility.png": "29b2",
	"./bottle_medium.png": "2123",
	"./bottle_regeneration.png": "3ee2",
	"./bottle_small.png": "daa6",
	"./bracer.png": "678b",
	"./branches.png": "2f7a",
	"./broadsword.png": "db03",
	"./broom_handle.png": "96be",
	"./buckler.png": "22dc",
	"./bullwhip.png": "ba8b",
	"./butterfly.png": "0e4b",
	"./ceremonial_robe.png": "c1ed",
	"./chainmail.png": "2ed7",
	"./cheese.png": "4ad2",
	"./chipped_vest.png": "7fa6",
	"./circlet.png": "693f",
	"./clarity.png": "c561",
	"./claymore.png": "c785",
	"./cloak.png": "87fa",
	"./cloak_of_flames.png": "2905",
	"./clumsy_net.png": "1fda",
	"./courier.png": "01cd",
	"./courier_dire.png": "0e1a",
	"./courier_dire_flying.png": "358b",
	"./courier_radiant.png": "098b",
	"./courier_radiant_flying.png": "605e",
	"./craggy_coat.png": "8bb6",
	"./crimson_guard.png": "5220",
	"./crimson_robe.png": "f796",
	"./crown.png": "7e51",
	"./cyclone.png": "5bbc",
	"./cyclone_2.png": "9d71",
	"./dagon.png": "f907",
	"./dagon_2.png": "e6c6",
	"./dagon_3.png": "9953",
	"./dagon_4.png": "0f7d",
	"./dagon_5.png": "2f3d",
	"./default.png": "58eb",
	"./demon_edge.png": "0468",
	"./desolator.png": "5bdd",
	"./desolator_2.png": "2083",
	"./diffusal_blade.png": "1c4d",
	"./diffusal_blade_2.png": "0f43",
	"./dimensional_doorway.png": "c9a9d",
	"./dragon_lance.png": "4c44",
	"./dragon_scale.png": "e78b0",
	"./dust.png": "a683",
	"./eagle.png": "82fb",
	"./echo_sabre.png": "828b",
	"./elixir.png": "d969",
	"./elven_tunic.png": "99a9",
	"./emptyitembg.png": "3309",
	"./enchanted_mango.png": "7753",
	"./enchanted_quiver.png": "6fcb",
	"./energy_booster.png": "972a",
	"./essence_ring.png": "5f3e",
	"./eternal_shroud.png": "ebd0",
	"./ethereal_blade.png": "1e6f",
	"./ex_machina.png": "a9b7",
	"./faded_broach.png": "d7af",
	"./faerie_fire.png": "e6b3",
	"./falcon_blade.png": "c277",
	"./fallen_sky.png": "ad9b",
	"./firecrackers.png": "5417",
	"./firework_mine.png": "ba1f",
	"./flask.png": "7c75",
	"./flask2.png": "954c",
	"./flicker.png": "b605",
	"./fluffy_hat.png": "0111",
	"./flying_courier.png": "58bb",
	"./force_boots.png": "16a6",
	"./force_staff.png": "73d3",
	"./fusion_rune.png": "e52e",
	"./gauntlets.png": "b908",
	"./gem.png": "cdc1",
	"./gem_of_true_sight.png": "cf31",
	"./ghost.png": "cd29",
	"./ghost_scepter.png": "4d61",
	"./giants_ring.png": "8dee",
	"./glimmer_cape.png": "2570",
	"./gloves.png": "5efc",
	"./gloves_of_haste.png": "f086",
	"./greater_clarity.png": "0bb8",
	"./greater_crit.png": "6cd0",
	"./greater_faerie_fire.png": "0b07",
	"./greater_mango.png": "54ae",
	"./greater_salve.png": "d813",
	"./greevil_whistle.png": "cf9f",
	"./greevil_whistle_toggle.png": "ff7a",
	"./grove_bow.png": "8693",
	"./guardian_greaves.png": "9c42",
	"./gungir.png": "648d",
	"./halloween_candy_corn.png": "7183",
	"./halloween_rapier.png": "50cc",
	"./hand_of_midas.png": "e859",
	"./havoc_hammer.png": "acf6",
	"./headdress.png": "91fa",
	"./heart.png": "79ac",
	"./heavens_halberd.png": "47e2",
	"./helm_of_iron_will.png": "316f",
	"./helm_of_the_dominator.png": "5cc4",
	"./helm_of_the_dominator_2.png": "af2f",
	"./helm_of_the_undying.png": "77e8",
	"./holy_locket.png": "b4fa",
	"./hood_of_defiance.png": "2aea",
	"./horizon.png": "a589",
	"./hurricane_pike.png": "334f",
	"./hyperstone.png": "8913",
	"./illusionist's_cape.png": "398f",
	"./imba_force_staff.png": "8ae0",
	"./imba_hood_of_defiance.png": "ff64",
	"./imba_hurricane_pike.png": "87e4",
	"./imba_radiance.png": "2645",
	"./imp_claw.png": "aa39",
	"./infused_raindrop.png": "bc4f",
	"./invis_sword.png": "4b7b",
	"./iron_talon.png": "6c3b",
	"./ironwood_tree.png": "84f5",
	"./javelin.png": "e492",
	"./kaya.png": "418b",
	"./kaya_and_sange.png": "bfe4",
	"./keen_optic.png": "1346",
	"./lesser_crit.png": "3489",
	"./lifesteal.png": "940c",
	"./lotus_orb.png": "b084",
	"./maelstrom.png": "d2e5",
	"./mage_slayer.png": "8f0e",
	"./magic_lamp.png": "930e",
	"./magic_stick.png": "9866",
	"./magic_wand.png": "782c",
	"./mango_tree.png": "7e22",
	"./manta.png": "b629",
	"./mantle.png": "d84e",
	"./mask_of_madness.png": "a599",
	"./medallion_of_courage.png": "fdf3",
	"./mekansm.png": "2298",
	"./meteor_hammer.png": "2db3",
	"./mind_breaker.png": "a0de",
	"./minotaur_horn.png": "45a2",
	"./mirror_shield.png": "6ec8",
	"./mithril_hammer.png": "f228",
	"./mjollnir.png": "4feb",
	"./mjollnir_arc.000.png": "d822",
	"./mjollnir_arc.001.png": "177c",
	"./mjollnir_arc.002.png": "7f64",
	"./monkey_king_bar.png": "b240",
	"./moon_shard.png": "24b3",
	"./mysterious_hat.png": "f5f1",
	"./mystery_arrow.png": "46fe",
	"./mystery_hook.png": "b35c",
	"./mystery_missile.png": "24ef",
	"./mystery_toss.png": "b01f",
	"./mystery_vacuum.png": "fd5f",
	"./mystic_staff.png": "3d90",
	"./necronomicon.png": "2117",
	"./necronomicon_2.png": "4f59",
	"./necronomicon_3.png": "6fd3",
	"./nether_shawl.png": "b7df",
	"./neutral.png": "707e",
	"./nian_flag_trap.png": "a849",
	"./ninja_gear.png": "6468",
	"./nokrash_blade.png": "d2fb",
	"./null_talisman.png": "39f6",
	"./nullifier.png": "b217",
	"./oblivion_staff.png": "9aa8",
	"./ocean_heart.png": "c261",
	"./octarine_core.png": "7968",
	"./ogre_axe.png": "d738",
	"./orb_of_corrosion.png": "a772",
	"./orb_of_destruction.png": "1c11",
	"./orb_of_venom.png": "ca4f",
	"./orchid.png": "47ca",
	"./overwhelming_blink.png": "54be",
	"./paladin_sword.png": "c336",
	"./penta_edged_sword.png": "d613",
	"./pers.png": "20a8",
	"./phase_boots.png": "bde0",
	"./philosophers_stone.png": "23de",
	"./phoenix_ash.png": "8a57",
	"./pipe.png": "9831",
	"./pirate_hat.png": "36e2",
	"./place_building.png": "c60e",
	"./platemail.png": "62df",
	"./pocket_tower.png": "16be",
	"./pog_assault.png": "8271",
	"./pog_ballista.png": "5e1c",
	"./pog_blink.png": "4534",
	"./pog_cyclone.png": "5ca3",
	"./pog_guardian_greaves.png": "fb2c",
	"./pog_maelstrom.png": "8319",
	"./pog_mekansm.png": "310d",
	"./pog_mjollnir.png": "7590",
	"./pog_phase_boots.png": "dceb",
	"./pog_pipe.png": "7145",
	"./pog_seer_stone.png": "2f4a",
	"./pog_shivas_guard.png": "5644",
	"./pog_vladmir.png": "65c6",
	"./point_booster.png": "d230",
	"./poor_man's_shield.png": "2f94",
	"./poor_mans_shield.png": "257e",
	"./possessed_mask.png": "cf71",
	"./power_treads.png": "68a9",
	"./power_treads_agi.png": "8914",
	"./power_treads_agi_colorblind.png": "f010",
	"./power_treads_int.png": "a665",
	"./power_treads_str.png": "d196",
	"./present.png": "51e3",
	"./prince's_knife.png": "7123",
	"./psychic_headband.png": "91ea",
	"./pupil's_gift.png": "adb7",
	"./quarterstaff.png": "a461",
	"./quelling_blade.png": "0387",
	"./quickening_charm.png": "477e",
	"./quicksilver_amulet.png": "9a4a",
	"./radiance.png": "14a6",
	"./radiance_inactive.png": "e50e",
	"./rapier.png": "41a6",
	"./reaver.png": "aabe",
	"./recipe.png": "fb90",
	"./recipe_scroll.png": "a96f",
	"./refresher.png": "ccb2d",
	"./refresher_shard.png": "d4b1",
	"./relic.png": "cfb1",
	"./repair_kit.png": "8582",
	"./ring_of_aquila.png": "f0fc",
	"./ring_of_aquila_active.png": "b2d65",
	"./ring_of_basilius.png": "57ce",
	"./ring_of_basilius_active.png": "3c7d",
	"./ring_of_health.png": "56c9",
	"./ring_of_protection.png": "45bf",
	"./ring_of_regen.png": "f278",
	"./river_painter.png": "6476",
	"./river_painter2.png": "7aa5",
	"./river_painter3.png": "a0ce",
	"./river_painter4.png": "50ec",
	"./river_painter5.png": "c75a",
	"./river_painter6.png": "bc06",
	"./river_painter7.png": "834d",
	"./robe.png": "09ac",
	"./rod_of_atos.png": "7d00",
	"./royal_jelly.png": "4069",
	"./salve.png": "3e4c",
	"./sange.png": "ab98",
	"./sange_and_yasha.png": "f93c",
	"./satanic.png": "86d0",
	"./seer_stone.png": "0972",
	"./shadow_amulet.png": "2bb0",
	"./sheepstick.png": "c773",
	"./shivas_guard.png": "194a",
	"./silver_edge.png": "d7ee",
	"./skadi.png": "26e7",
	"./slippers.png": "41a66",
	"./slippers_of_halcyon.png": "dc83",
	"./smoke_of_deceit.png": "5d31",
	"./sobi_mask.png": "db22",
	"./solar_crest.png": "0ea1",
	"./soul_booster.png": "865b",
	"./soul_ring.png": "44af",
	"./spell_prism.png": "e05c",
	"./sphere.png": "3492",
	"./spider_legs.png": "e241",
	"./spirit_vessel.png": "3d4c",
	"./staff_of_wizardry.png": "af8f",
	"./stormcrafter.png": "5556",
	"./stout_shield.png": "0a04",
	"./stygian_desolator.png": "e0a5",
	"./super_blink.png": "6c06c",
	"./swift_blink.png": "4f94",
	"./talisman_of_evasion.png": "4f83",
	"./tango.png": "1d96",
	"./tango_single.png": "b703",
	"./telescope.png": "f983",
	"./the_leveller.png": "482a",
	"./third_eye.png": "b4ad",
	"./timeless_relic.png": "4638",
	"./titan_sliver.png": "ab91",
	"./tombstone.png": "97ac",
	"./tome_of_aghanim.png": "3aa9",
	"./tome_of_knowledge.png": "8acd",
	"./tpscroll.png": "eef2",
	"./traditional_crackers.png": "e32e",
	"./tranquil_boots.png": "5935",
	"./tranquil_boots_active.png": "7d9b",
	"./travel_boots.png": "d0d2",
	"./travel_boots_2.png": "9bcf",
	"./travel_boots_tinker.png": "3073",
	"./travel_slippers.png": "6764",
	"./trickster_cloak.png": "6bac",
	"./trident.png": "f594",
	"./trusty_shovel.png": "b9f3",
	"./ultimate_orb.png": "caa7",
	"./ultimate_scepter.png": "8cbe",
	"./urn_of_shadows.png": "b9dd",
	"./vambrace.png": "362f",
	"./vambrace_agility.png": "6e9b",
	"./vambrace_intelligence.png": "e3d0",
	"./vambrace_strength.png": "2778",
	"./vampire_fangs.png": "6c1d",
	"./vanguard.png": "7d74",
	"./veil_of_discord.png": "d0d9",
	"./vitality_booster.png": "932e",
	"./vladmir.png": "e3fb",
	"./void_stone.png": "323c",
	"./ward_dispenser.png": "1059",
	"./ward_dispenser_sentry.png": "943b",
	"./ward_observer.png": "b28f",
	"./ward_sentry.png": "249b",
	"./wind_lace.png": "e242",
	"./wind_waker.png": "1707",
	"./winter_cake.png": "5270",
	"./winter_coal.png": "38c0",
	"./winter_coco.png": "3436",
	"./winter_cookie.png": "43d9",
	"./winter_greevil_chewy.png": "95f9",
	"./winter_greevil_garbage.png": "d529",
	"./winter_greevil_treat.png": "de42",
	"./winter_ham.png": "ca66",
	"./winter_kringle.png": "1403",
	"./winter_mushroom.png": "8505",
	"./winter_skates.png": "519b",
	"./winter_snowball.png": "a657",
	"./winter_stocking.png": "e8f2",
	"./winter_woolies.png": "80c5",
	"./witch_blade.png": "14a9",
	"./witless_shako.png": "2ee1",
	"./woodland_striders.png": "0353",
	"./wraith_band.png": "cbf9",
	"./yasha.png": "eabb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4aec";